export default __webpack_public_path__ + "static/media/personUsingPC.b9aa74aa.svg";